import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import {
    getCurrentUser,
    getSelectedSupplier,
    getSupplierTasks,
    getAgencyId,
    getAdmins,
    getTasksListDataFetchState,
} from 'reducers';
import { fetchSupplierTasks, editTask, createTask } from 'actions/supplierActions';
import { fetchAdmins } from 'actions/agencyActions';
import { tasksDataFetchingSuccess } from 'actions/sharedActions';

import TaskCardList from 'components/Person/Tasks/TaskCardList';
import isHoliday from 'hoc/isHoliday';

const Tasks = ({
    match,
    currentUser,
    agencyId,
    selectedUser,
    fetchSupplierTasks,
    fetchAdmins,
    tasksDataFetchingSuccess,
    editTask,
    createTask,
    tasks,
    isHoliday,
    admins,
    dataFetchState
}) => {

    useEffect(() => {
        fetchSupplierTasks(match.params.id, agencyId);
        fetchAdmins(agencyId);

        return () => tasksDataFetchingSuccess();
    }, []);

    const submitTaskHandler = (task, clientId, agencyId) => {
        if (task._id) {
            return editTask(task, clientId, agencyId);
        }

        createTask(task, clientId, agencyId);
    };

    return (
        <TaskCardList
            dataFetchState={dataFetchState}
            tasks={tasks}
            currentUser={currentUser}
            selectedUser={selectedUser}
            submitTaskHandler={submitTaskHandler}
            agencyId={agencyId}
            renderHolidays={isHoliday}
            taskAdmins={admins}
        />
    )
};

const mapStateToProps = (state, props) => ({
    currentUser: getCurrentUser(state),
    agencyId: getAgencyId(state),
    selectedUser: getSelectedSupplier(state, props.match.params.id),
    tasks: getSupplierTasks(state),
    admins: getAdmins(state),
    dataFetchState: getTasksListDataFetchState(state),
});

const mapDispatchToProps = {
    fetchSupplierTasks,
    editTask,
    createTask,
    isHoliday,
    fetchAdmins,
    tasksDataFetchingSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tasks);
